<template>
  <div class="container">
    <div class="content" :style="{'max-width': width}">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Window',
  props: {
    width: { type: String, default: '440px' }
  }
}
</script>

<style lang="scss" scopped>
@import "@/assets/style/scss/_vars.scss";
@import "@/assets/style/scss/_extends.scss";

.container {
  background-color: $bg-content-base;
  align-items: center;
  justify-content: center;
}

.content {
  @extend %flex-column;

  padding: 30vh 0;
  width: 100%;
  justify-content: center;
}
</style>
